(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalEnterKey', [rfGlobalEnterKeyFn]);

    function rfGlobalEnterKeyFn() {
        // handle enter key pressed - evaluate function
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                // catch enter key
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.rfGlobalEnterKey);
                    });

                    event.preventDefault();
                }
            });
        };
    }
})();
